export default __webpack_public_path__ + "static/media/icon_fb.59ee06e2.svg";